import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DndObservablesService {
  readonly isDraggingGlobal = new BehaviorSubject<string>('');

  isDraging(): Observable<string> {
    return this.isDraggingGlobal.asObservable();
  }

  setDragging(type: string): void {
    this.isDraggingGlobal.next(type);
  }

  setNotDragging(): void {
    this.isDraggingGlobal.next('');
  }
}
